/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsCloneReportDefinitionMutationResponse, AuditReportsCloneReportDefinitionPathParams, AuditReportsCloneReportDefinition401, AuditReportsCloneReportDefinition403, AuditReportsCloneReportDefinition404 } from "../models/AuditReportsCloneReportDefinition";

export function getAuditReportsCloneReportDefinitionUrl(id: AuditReportsCloneReportDefinitionPathParams["id"]) {
  const res = { method: 'POST', url: `/audit-reports/v1/report-definitions/${id}/clone` as const }
  return res
}

/**
 * @description Creates a copy of an existing report definition. The cloned definition uses the same blueprint version as the source and is not set as default.
 * @summary Clone report definition
 * {@link /audit-reports/v1/report-definitions/:id/clone}
 */
export async function auditReportsCloneReportDefinition(id: AuditReportsCloneReportDefinitionPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsCloneReportDefinitionMutationResponse, ResponseErrorConfig<AuditReportsCloneReportDefinition401 | AuditReportsCloneReportDefinition403 | AuditReportsCloneReportDefinition404>, unknown>({ method : "POST", url : getAuditReportsCloneReportDefinitionUrl(id).url.toString(), ... requestConfig })
  return res.data
}